module.exports = __webpack_public_path__ + "img/hr-cargo-wagon-mask-3.5c0b8915.png";